import {observable} from 'mobx';
import App from './App';

class Categories {
  id;

  name;

  order;

  @observable apps = [];

  updateFromJson(json) {
    this.id = json.id;
    this.name = json.name;
    this.order = json.order;
    if (json.apps) {
      this.apps = (json.apps || []).map(app => this.updateAppFromJson(app));
    }
  }

  updateAppFromJson(json) {
    const app = new App();
    app.id = json.id;
    app.code = json.code;
    app.name = json.name;
    app.description = json.description;
    app.type = json.type;
    app.createdTime = json.createdTime;
    app.status = json.status;
    app.order = json.order;
    app.url = json.url;
    app.isShortcut = json.isShortcut;
    app.sourceApp = json.sourceApp;
    app.structure = json.structure;
    if (json.structure) {
      app.structure.id = json.structure.id;
      app.structure.name = json.structure.name;
    } else {
      app.structure = {};
    }

    if (json.category) {
      app.category.updateFromJson(json.category);
    }
    return app;
  }
}

export default Categories;
